import styled from 'styled-components';

import {SectionTitle} from '../../../atoms/titles';
import {palette, fontWeights} from '../../../../lib/styleVariables';
import {fontFamiliesR4} from '../../../../lib/styleVariablesR4';

const getTitleColor = (color?: string) => {
  switch (color) {
    case 'gray':
      return palette.black.base;
    case 'black':
      return palette.white.highlight;
    default:
      return palette.white.highlight;
  }
};

const StyledTitle = styled(SectionTitle)<{color?: string; titleCss?: string}>`
  font-family: ${fontFamiliesR4.body};
  font-weight: ${fontWeights.semibold};
  align-self: flex-end;
  color: ${props => getTitleColor(props.color)};
  margin: 0;
  ${props => props.titleCss || ''}
`;

export const NavigationCallToActionSectionTitle = StyledTitle;
